"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarAction = void 0;
const Toolbar_1 = require("../../Toolbar");
function toolbarAction({ groupId, title, icon, id, isAction = true, decorators, handler, contextMenu = true, disabled, tooltip, hidden }) {
    const result = () => {
        return {
            groupId,
            id: id,
            type: Toolbar_1.TOOLBAR_ITEM_TYPE.button,
            text: title,
            iconSrc: icon,
            onClick: () => handler === null || handler === void 0 ? void 0 : handler(),
            isAction: isAction,
            disabled,
            tooltip,
            hidden,
            decorators
        };
    };
    if (contextMenu) {
        result.contextMenu = Object.assign({ id: id, icon,
            title,
            disabled,
            hidden,
            decorators,
            handler }, (typeof contextMenu === 'object' ? contextMenu : {}));
    }
    return result;
}
exports.toolbarAction = toolbarAction;
//# sourceMappingURL=toolbarAction.js.map